export const cardBodyWrapStyles = theme => ({
  '& > hr': {
    width: '100%',
  },
  alignItems: 'center',
  display: 'grid',
  gap: theme.spacing(0, 2),
  gridTemplate: '0.5fr 0.5fr 1fr / repeat(2, 1fr)',
  justifyItems: 'center',
  paddingBottom: theme.spacing(1.5),
});

export const datesTextStyles = theme => ({
  marginBottom: theme.spacing(1),
});

export const ellipsesStyles = theme => ({
  '&:hover': {
    backgroundColor: theme.palette.secondary.light,
  },
  backgroundColor: theme.palette.white,
  borderRadius: '100%',
  color: theme.palette.secondary.main,
  cursor: 'pointer',
  height: 24,
  marginRight: -11,
  marginTop: 1,
  minWidth: 24,
  paddingBottom: 0,
  width: 24,
});

export const ellipsesActiveStyles = theme => ({
  backgroundColor: theme.palette.secondary.medium,
});

export const labelTextStyles = {
  fontSize: 18,
  fontWeight: 300,
  letterSpacing: '0.3px',
  lineHeight: '28px',
};

export const limitTextStyles = theme => props => ({
  color: props.validLimitMet ? theme.palette.error.dark : theme.palette.success.dark,
});

export const twoPartyLabelStyles = theme => ({
  ...theme.typography.body2,
  color: theme.palette.text.primary,
});

export const twoPartyLabelWithActionsStyles = theme => ({
  ...theme.typography.body2,
  color: theme.palette.text.primary,
  marginTop: theme.spacing(1),
});

export const twoPartyPendingStyles = theme => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  margin: theme.spacing(1, 0, 0, 0),
});
